import type { ProgressStep } from "./types";

export function mergeProgressSteps(
  existing: ProgressStep[],
  next: ProgressStep,
): ProgressStep[] {
  const index = existing.findIndex((step) => step.step === next.step);
  if (index === -1) {
    return [...existing, next];
  }

  const updated = [...existing];
  updated[index] = next;
  return updated;
}

export type ContentGenType = "questions" | "vocabulary" | "speaking-guide";

export function initialProgressSteps(
  contentTypes: ContentGenType[],
): { step: ContentGenType; message: string; completed: boolean }[] {
  return contentTypes.map((ct) => ({
    step: ct,
    message:
      ct === "questions"
        ? "Generating questions..."
        : ct === "vocabulary"
          ? "Generating vocabulary..."
          : "Creating speaking guide...",
    completed: false,
  }));
}